import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {minZoomForLevel17, setupS2} from "../../../utils/s2";
import SubmitPending from "./SubmitPending";
import RemovePending from "./RemovePending";
import store from '../../../store';
import ViewPending from "./ViewPending";
import LinkDiscord from "../../Helper/Discord/LinkDiscord";
import {Page} from "../../../store/coreSlice";

let onBoundsChanged = null;
const S2Cells = (props) => {
	const [lastZoom, setLastZoom] = useState(null);
	const [dialog, setDialog] = useState(null);

	const shouldShowLevel17 = () => {
		return props.zoom >= minZoomForLevel17;
	};

	// useEffect(() => {
			// if( shouldShowLevel17() ) {
			// 	console.log("Showing cells because mapsLoaded/pendingSubs");
			// 	showCells();
			// }
	// eslint-disable-next-line
	// }, [props.mapLoaded, props.pendingSubmissions]);

	useEffect(() => {
		if( props.page === Page.S2 ) {
			console.log("Page is now S2, showing cells");
			showCells();
		} else {
			hideCells();
		}
		// return () => {
		// 	console.log("Destroying, hiding cells");
		// 	hideCells();
		// }
		// eslint-disable-next-line
	}, [props.page]);

	useEffect(() => {
		if( props.page !== Page.S2 )
			return;

		if( props.mapBounds && onBoundsChanged ) {
			console.log("Bounds changed, update S2 cells...")
			onBoundsChanged();
			paintPendingSubmissions();
			paintPortalCells();
		} // eslint-disable-next-line
	}, [props.mapBounds]);

	useEffect(() => {
		if( props.page !== Page.S2 )
			return;

		// console.log("Zoomed from " + lastZoom + ' to ' + props.zoom);
		if( props.zoom < minZoomForLevel17 && lastZoom >= minZoomForLevel17 ) {
			// console.log("Hiding " + Object.values(window.s2Polygons[17]).length + " S2 polygons");
			Object.values(window.s2Polygons[17]).forEach(polygon => polygon.setMap(null));
		} else if( props.zoom >= minZoomForLevel17 && lastZoom < minZoomForLevel17 ) {
			// console.log("Showing " + Object.values(window.s2Polygons[17]).length + " S2 polygons");
			Object.values(window.s2Polygons[17]).forEach(polygon => polygon.setMap(window.map));
			console.log("Showing cells because zoom " + props.zoom + " and " + lastZoom);
			showCells();
		}
		setLastZoom(props.zoom); // eslint-disable-next-line
	}, [props.zoom]);

	useEffect(() => {
		paintPendingSubmissions(); // eslint-disable-next-line
	}, [props.pendingSubmissions]);

	// Take all visible gyms/stops and make their polygons grey
	const paintPortalCells = () => {
		[...Object.values(props.gyms), ...Object.values(props.stops)].forEach(portal => {
			const polygon = window.s2Polygons[17][portal['s2-17']];
			if( polygon )
				polygon.setOptions({fillColor: '#000000', fillOpacity: 0.2});
		});
	};

	const paintPendingSubmissions = () => {
		if( !props.pendingSubmissions )
			return;

		Object.keys(props.pendingSubmissions).forEach(key => {
			// const data = props.pendingSubmissions[key];
			const polygon = window.s2Polygons[17][key];
			if( polygon )
				polygon.setOptions({fillColor: '#ffff00', fillOpacity: 0.4});
		});
	};

	const onCreatePolygon = (polygon, key) => {
		polygon.addListener('click', (e) => {
			const state = store.getState(); // Gross, but without this, we get the old state
			const hasPortal = [...Object.values(state.marker.gyms), ...Object.values(state.marker.stops)].filter(portal => portal['s2-17'] === key).length > 0;
			const hasPending = state.core.pendingSubmissions[key];
			const latLng = key.split(',');

			if (!state.core.discordUser) {
				setDialog(<LinkDiscord title='Pending Stop Submissions' onClose={() => setDialog(null)}/>);
			} else if (hasPending) {
				const isMine = hasPending.username === state.core.discordUser;
				if (isMine)
					setDialog(<RemovePending latitude={+latLng[0]} longitude={+latLng[1]} keyName={key}
											 polygon={polygon}
											 onClose={() => setDialog(null)}/>);
				else
					setDialog(<ViewPending pending={hasPending} onClose={() => setDialog(null)} />);
			} else if (hasPortal) {
				// NOOP
			} else {
				setDialog(<SubmitPending latitude={+latLng[0]} longitude={+latLng[1]} keyName={key}
										 onClose={() => setDialog(null)}/>);
			}
		});
	};

	const showCells = () => {
		Object.values(window.s2Polygons[14]).forEach(polygon => polygon.map === null && polygon.setMap(window.map));
		if( shouldShowLevel17() )
			Object.values(window.s2Polygons[17]).forEach(polygon => polygon.map === null && polygon.setMap(window.map));

		if( onBoundsChanged === null ) {
			onBoundsChanged = setupS2(onBoundsChanged, onCreatePolygon);
			onBoundsChanged();
		}

		paintPortalCells();
	};

	const hideCells = () => {
		console.log("Hide cells");
		Object.values(window.s2Polygons[14]).forEach(polygon => polygon.setMap(null));
		Object.values(window.s2Polygons[17]).forEach(polygon => polygon.setMap(null));
		// window.map.setOptions({minZoom: 1});
	};

	return (
		<>{dialog}</>
	);
};

const mapStateToProps = (state) => {
	return {
		discordUser: state.core.discordUser,
		mapLoaded: state.core.mapLoaded,
		mapBounds: state.map.mapBounds,
		zoom: state.map.zoom,
		pendingSubmissions: state.core.pendingSubmissions,
		gyms: state.marker.gyms,
		stops: state.marker.stops,
		page: state.core.page,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(S2Cells);